import { Reveal } from "./Reveal";
import { SERVICES } from "../lib/content";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <span className="overline text-accent">Areas of care</span>
            <h2 className="font-serif text-primary text-4xl sm:text-5xl tracking-tight leading-[1.02] mt-5 max-w-xl">
              Complete care, through every stage of womanhood.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-muted-foreground max-w-sm text-sm sm:text-base">
              From a first pregnancy to menopause and beyond — thoughtful, specialised support you can rely on.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`service-card-${i}`}
                className="group h-full p-7 rounded-2xl border border-border bg-card hover:-translate-y-1 hover:border-accent transition-[transform,border-color] duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="font-serif text-3xl text-secondary/80 group-hover:text-accent transition-colors duration-300">
                    0{i + 1}
                  </span>
                  <ArrowUpRight className="text-muted-foreground group-hover:text-primary transition-colors duration-300" size={20} />
                </div>
                <h3 className="font-serif text-2xl text-primary mt-5">{s.title}</h3>
                <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
